/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("ButtonNode", ["StandardNode", "NodeFactory"], function (context, cls) {
  /**
   * @class ButtonNode
   * @memberOf classes
   * @extends classes.StandardNode
   */
  class ButtonNode extends cls.StandardNode /** @lends classes.ButtonNode.prototype */ {
    /**
     * @inheritDoc
     */
    _createController(additionalBindings) {
      return cls.ControllerFactory.create(this._tag, {
        anchor: this,
        parent: this._parent,
        ui: this.getApplication().getNode(0),
        additionalBindings: additionalBindings,
        form: this.getAncestor("Form")
      });
    }
  }
  cls.ButtonNode = ButtonNode;
  cls.NodeFactory.register("Button", cls.ButtonNode);
});
